// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://nvwulezblkdyiztmpjtk.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im52d3VsZXpibGtkeWl6dG1wanRrIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTIzNDAyMTksImV4cCI6MjA2NzkxNjIxOX0.6SJAG8MOypGup7Lv0pzRsOp2-F9wxMCU2XO6z1W3Vak";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});